export enum Route {
  Unassigned = 'unassigned',
  MyOpen = 'my-open',
  Open = 'open',
  Pending = 'pending',
  Solved = 'solved',
  Spam = 'spam',
  Search = 'search',
  All = 'all',
}
